export const CONDITION_MULTIPLIERS = { NM: 1.0, LP: 0.85, MP: 0.65, HP: 0.45, DMG: 0.25 };

export const CONDITION_LABELS = {
  NM: "Near Mint",
  LP: "Lightly Played",
  MP: "Moderately Played",
  HP: "Heavily Played",
  DMG: "Damaged",
};

export function cardTotalValue(card) {
  const qty = card.quantity || 1;
  if (card.base_price_nm == null) {
    return card.current_price != null ? card.current_price * qty : null;
  }
  const copies = card.copy_conditions?.length
    ? card.copy_conditions
    : Array(qty).fill(card.condition || "NM");
  return copies.reduce((sum, c) => sum + card.base_price_nm * (CONDITION_MULTIPLIERS[c] ?? 1), 0);
}
